import React from 'react';
import { motion } from 'framer-motion';
interface SectionWrapperProps {
  children: React.ReactNode;
  className?: string;
  bg?: string;
  id?: string;
}
export const SectionWrapper: React.FC<SectionWrapperProps> = ({
  children,
  className = '',
  bg = 'bg-transparent',
  id
}) => {
  return <section id={id} className={`w-full py-16 md:py-24 px-4 sm:px-6 lg:px-8 ${bg} ${className}`} data-id="element-119">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.7,
      ease: 'easeOut'
    }} className="max-w-3xl mx-auto" data-id="element-120">
        {children}
      </motion.div>
    </section>;
};